import Fressnapf from './Fressnapf';

export default Fressnapf;
